import { render, staticRenderFns } from "./allotTaskSchedule.vue?vue&type=template&id=798e3a54&"
import script from "./allotTaskSchedule.vue?vue&type=script&lang=js&"
export * from "./allotTaskSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports